export enum ProxyStep {
  RELATIONSHIPS = 1,
  ASSIGN_PROXY = 2,
}
